<template>
    <validation
      :messageError="!!errorMessage ? ($attrs.messageError || errorMessage) : ''"
      v-bind="$attrs"
      id="base-select-">
    <select
      v-bind="attrs"
      v-on="listeners"
      :id="'selectOption' + dynamicId"
      :value="modelValue"
      class="custom-select text-muted">
      <!-- create option default selected null-->
      <option
        value=""
        v-if="showDefaultOption"
        disabled
        selected>
        Selecione
      </option>
      <option
        v-for="(option, index) in options"
        :key="index"
        :value="option.value">
        {{option.label}}
      </option>
    </select>
  </validation>
</template>

<script>
/* eslint-disable */
import Validation from './Validation.vue';
import { useField, useForm } from 'vee-validate';
export default {
  name: 'BaseSelect',
  inheritAttrs: false,
  data () {
    return {
      error: null,
      dynamicId: null,
      fieldError: {
        isValid: true,
        message: ''
      }
    };
  },
  components: {
    Validation
  },
  props: {
    value: {
      default: null
    },
    options: {
      type: Array,
      default: () => []
    },
    showDefaultOption: {
      type: Boolean,
      default: true
    },
    modelValue: {
      default: null
    }
  },
  computed: {
    listeners () {
      return {
        // TODO: ajustar listeners
        // ...this.$listeners,
        input: this.onInput,
        blur: this.handleBlur,
        ...this.attrs
      };
    },
    attrs () {
      /* eslint-disable no-unused-vars */
      const {
        validate,
        class: _class,
        style,
        ...attrs
      } = this.$attrs;

      return attrs;
    }
  },
  watch: {},
  methods: {
    generateDynamicId () {
      return Math.random().toString(36).substr(2, 9);
    },
    onInput (event) {
      // this.handleChange(event);
      this.$emit('update:modelValue', (event && event.target && event.target.value) || null);
    }
  },
  beforeMount () {
    this.dynamicId = this.generateDynamicId();
  },
  setup (props, {attrs}) {
    const fieldName = attrs.fieldName || attrs.name || attrs.label || 'baseSelect';

    const {
      errorMessage,
      handleBlur,
      handleChange
    } = useField(fieldName, attrs.validate, {
      initialValue: props.modelValue
    });

    const form = useForm();

    // Verificar se form existe, tem o método setValues e se há um nome de campo válido antes de chamar setValues
    if (form && typeof form.setValues === 'function' && fieldName) {
      try {
        const fieldValue = props.modelValue !== undefined && props.modelValue !== null ? props.modelValue : null;
        form.setValues(fieldName, fieldValue);
      } catch (error) {
        // Ignorar erros se o form não estiver configurado corretamente
        console.warn('BaseSelect: Não foi possível definir o valor no formulário', error);
      }
    }

    return {
      errorMessage,
      handleBlur,
      handleChange
    };
  },
  mounted () {
    this.$nextTick(() => {
      const select = document.getElementById(`selectOption${this.dynamicId}`);
      if (select) {
        select.addEventListener('focus', () => {
          select.classList.remove('text-muted');
        });
        select.addEventListener('blur', () => {
          if (select.value) select.classList.remove('text-muted');
          else select.classList.add('text-muted');
        });
      }
    });
  }
};
</script>

<style lang="scss">
  .custom-select {
    height: 45px;
  }
</style>
